import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import FeaturedProducts from "./components/FeaturedProducts";
import FeaturedArticles from "./components/FeaturedArticles";
import BrandSection from "./components/BrandSection";
import FAQSection from "./components/FAQSection";
import NewsletterSection from "./components/NewsletterSection";
import { homepageSchema } from "@/mocks/schema";

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homepageSchema) }}
      />

      <HeroSection />
      <CategorySection />
      <FeaturedProducts />
      <FeaturedArticles />
      <BrandSection />
      <FAQSection />
      <NewsletterSection />
    </>
  );
}